export default function room() {

  $(window).on('scroll', function() {
    var pos = $('.service-content').offset();
    var scrollTop = $(window).scrollTop();
    var headerH = $('#header').height();
    
    if (pos.top - scrollTop < headerH) {
      $('.nav-service').addClass('sticky');
      $('.nav-service').css('top', headerH);
      $('.overview-content').addClass('sticky');
    } else {
      $('.nav-service').removeClass('sticky');
      $('.nav-service').css('top', '0');
      $('.overview-content').removeClass('sticky');
    }

    if ($(window).width() >= 768) {
      var info_pos = $('.service-info').offset();
      var info_height = $('.service-info').outerHeight();
      var overview_pos = $('.overview-content').offset();
      var overview_height = $('.overview-content').outerHeight();
      
      if (info_pos.top + info_height <= overview_pos.top + overview_height) {
        $('.overview-content').addClass('sticky-end');
        $('.overview-content').removeClass('sticky');
      }

      if ($('.overview-content').hasClass('sticky-end') && $('.overview-content').offset().top > scrollTop + 185) {
        $('.overview-content').removeClass('sticky-end');
        $('.overview-content').addClass('sticky');
      }
    }
  });

  $('.nav-service-toggle').click(function(e){
    e.preventDefault();
    $('.nav-service-toggle').toggleClass('open');
    $('#menu-services-menu').toggleClass('open');
  });

  $('#menu-services-menu a').click(function(e){
    e.preventDefault();

    $('#menu-services-menu li').removeClass('current-menu-item');
    $(this).parent().addClass('current-menu-item');
    $('.nav-service-toggle').text($(this).text());

    if ($(window).width() < 768) {
      $('.nav-service-toggle').removeClass('open');
      $('#menu-services-menu').removeClass('open');
    }

    $.ajax({
      url: $(this).attr('href'),
      success: function(res){
        
        $('.service-content').css('height', $('.service-content').css('height'));

        $('.service-info').fadeOut('1500', function(){
          var pos = $('.service-content').offset().top;

          $('html, body').animate({
            scrollTop: pos - $('#header').height()
          }, 800);

          $('.service-info').html($(res).find('.service-info').html());
          $('.service-info').fadeIn('1500');

          $('.service-content').css('height', 'auto');
        });
      }
    });
  });

}